import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {Link} from "react-router-dom";
import React from "react";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher';
import { usePageMetadataWithRoute } from './hooks/usePageMetadata';

function App() {
  const { t, i18n } = useTranslation('election');

  // Page metadata for home page
  const { title, description } = usePageMetadataWithRoute('/');

  // Check if current language is RTL (Arabic)
  const isRTL = i18n.language === 'ar';

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <div className={`homepage-container ${isRTL ? 'rtl' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="language-switcher-container position-fixed top-0 end-0 m-3" style={{ zIndex: 1000 }}>
        <LanguageSwitcher />
      </div>
      
      <div className="container-fluid h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 col-md-8 col-lg-6 text-center">
            <div className="hero-content">
              <h1 className="display-2 fw-bold mb-4 hero-title">{t('homepage.title')}</h1>
              <p className="lead mb-5 hero-subtitle">
                {t('homepage.subtitle')}
              </p>
              <div className="hero-actions mb-3">
                <Link
                  to="/create-election"
                  className="btn btn-primary btn-lg hero-cta px-5 py-3"
                >
                  <span>{t('homepage.createButton')}</span>
                </Link>
              </div>
              <p className="privacy-note">
                {t('homepage.privacyText')}{' '}
                <Link to="/privacy" className="privacy-link text-decoration-none">
                  {t('homepage.privacyLink')} →
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default App;
